<template>
  <action-dispatcher
    action="courses/getResource"
    :parameters="$route.params.id"
    class="view-audio container py-5 text-light my-lg-5"
  >
    <button
      class="bg-transparent border-0 text-light font-weight-bold"
      @click="$router.go(-1)"
    >
      <i class="fas fa-chevron-left mr-2" />
      Voltar
    </button>
    <div class="row align-items-center">
      <div class="py-3 col-5 col-lg-3">
        <div
          class="img"
          v-if="resource.picture"
          :style="`background-image: url(${resource.picture});`"
        />
      </div>
      <div class="py-3 col-7 d-lg-none">
        <h5 class="mb-0">{{ resource.name }}</h5>
      </div>
      <div class="py-3 col-lg-9">
        <h5 class="mb-0 d-none d-lg-block mb-4">{{ resource.name }}</h5>

        <audio
          v-if="resource.file"
          crossorigin
          playsinline
          controls
          class="w-100"
        >
          <source :src="resource.file" :type="type" />
        </audio>
        <iframe
          v-else
          class="w-100 border-0"
          :src="src"
          :height="iframeHeight"
        />
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import { get, last } from "lodash";

export default {
  computed: {
    ...mapState("courses", ["resource"]),
    type() {
      return "audio/" + last(get(this.resource, "file", "").split("."));
    },
    src() {
      if (get(this.resource, "link", "").indexOf("player") > 0) {
        return this.resource.link;
      }
      return `https://w.soundcloud.com/player/?url=${this.resource.link}`;
    },
    iframeHeight() {
      if (get(this.resource, "link", "").indexOf("playlists") > 0) {
        return 450;
      }
      return 170;
    }
  }
};
</script>

<style lang="scss" scoped>
.view-audio {
  .img {
    padding-bottom: 100%;
    width: 100%;
    background-size: cover;
    border-radius: 3px;
  }
}
</style>
